import PageHeader from "@/app/shared/page-header";
import CreateEditRole from "@/app/shared/roles-permissions/create-role";
import { fetchRoleById } from "@/server/api-services";
import { Order, Role } from "@/types";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";

export default function EditRolePage() {
    const { id } = useParams<{ id: string }>();

    const pageHeader = {
        title: "User Management",
        breadcrumb: [
            {
                href: "/",
                name: "Home",
            },
            {
                name: "User Management",
            },
            {
                name: "Create Role",
            },
        ],
    };

    const [role, setRole] = useState<Role>({} as Role);

    useEffect(() => {
        fetchOrder();
    }, []);

    const fetchOrder = async () => {
        if (!id) return;

        const response = await fetchRoleById(id as string);

        if (response.statusCode !== 200) {
            toast.error("Failed to fetch order");
            return;
        }
        var data = response.data as {
            id: string;
            name: string;
            normalizedName: string;
            permission?: string;
        };

        var role = { ...data, permission: data.permission?.split(",") };

        setRole(role);
    };

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            ></PageHeader>
            <CreateEditRole isEdit={true} register={role} />
        </>
    );
}
